export class UpdateTipoContratoQuienPagaServicioRequest {
  public id!: number
  public idTipoContrato!: number
  public idQuienPaga!: number
  public idServicio!: number
}
